import { FormControl, InputLabel, MenuItem, Select, Box, Typography } from '@mui/material'
import { useForm } from 'hooks/useForm'
import React, { memo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { homologations, jobs, prePayrollBaseCalcs1, prePayrollBaseCalcs2, tabulatorUses, unitTypes } from './values'
import { ContractRuleAccordion } from './ContractRuleAccordion'
import { generateRandomID } from 'helpers/generateRandomID'
import RegularButton from 'components/CustomButtons/Button'
import AddIcon from "@mui/icons-material/Add";

export const FormContractVariantEdit = memo((props) => {
  const { setNewVariants, setVariants, variants, variant, periodCalc, idStation } = props.variantHandlers
  const { rulesObj, deleteMode } = useSelector(state => state.contractsCatalog)
  const [jobsSelect, setJobsSelect] = useState(jobs)
  const [rules, setRules] = useState([])
  const [newRules, setNewRules] = useState(true)
  const [rulesKeys, setRulesKeys] = useState([])
  const [prePayrollBaseCalcsFiltered, setPrePayrollBaseCalcsFiltered] = useState([...prePayrollBaseCalcs1, ...prePayrollBaseCalcs2])
  const [unitTypesSelect, setUnitTypesSelect] = useState(unitTypes)
  const { inputValues, handleInputOnChange, handleNewValues } = useForm({
    unitType: '',
    job: '',
    prePayrollBaseCalc: '',
    tabulatorUse: '',
    homologation: ''
  })
  const { unitType, job, prePayrollBaseCalc, tabulatorUse, homologation } = inputValues
  useEffect(() => {
    if (variant.unitType || variant.job || variant.prePayrollBaseCalc || variant.tabulatorUse || variant.homologation || variant.rules) {
      handleNewValues({
        unitType: variant.unitType,
        job: variant.job,
        prePayrollBaseCalc: variant.prePayrollBaseCalc,
        tabulatorUse: variant.tabulatorUse,
        homologation: variant.homologation
      })
      if (variant.rules && variant.rules.length && Object.keys(variant.rules[0]).length > 2) {
        const filteredRules = variant.rules.reduce((acc, curr) => {
          if(!acc[curr.idRule]) acc[curr.idRule] = {
            ...rulesObj[curr.idRule],
            itemId: generateRandomID(32),
            ruleKeys: [],
            isComplete: 'good'
          }
          acc[curr.idRule] = {
            ...acc[curr.idRule],
            ruleKeys: [...acc[curr.idRule].ruleKeys, {id: curr.idRuleKey, value: curr.value}]
          }
          return acc
        }, {})
        setRules([...rules, ...Object.keys(filteredRules).map(idRule => filteredRules[idRule])])
        setRulesKeys([...Object.keys(filteredRules).map(idRule => filteredRules[idRule].ruleKeys.map(ruleKey => ({idRule, idRuleKey: ruleKey.id }))).flat()])
      }
    }
    //eslint-disable-next-line 
  }, [variant])

  useEffect(() => {
    const rulesCompleted = rules.filter(rule => rule.isComplete === 'bad').length === 0
    const isComplete = (unitType && job && prePayrollBaseCalc && tabulatorUse && homologation && rulesCompleted) ? 'good' : 'bad'
    if(unitType || job || prePayrollBaseCalc || tabulatorUse || homologation) {
      if(
        unitType !== variant?.unitType || 
        job !== variant?.job || 
        prePayrollBaseCalc !== variant?.prePayrollBaseCalc || 
        tabulatorUse !== variant?.tabulatorUse || 
        homologation !== variant?.homologation ||
        isComplete !== variant?.isComplete ||
        rulesKeys.length !== variant?.rules?.length
      ) {
        setVariants(variants.map(item => {
          if (item.id === variant.id) {
            return {
              ...variant,
              name: job || unitType ? `${job} ${unitType}` : variant.name,
              unitType,
              job,
              prePayrollBaseCalc,
              tabulatorUse,
              homologation,
              isComplete,
              rules: rulesKeys
            }
          }
          else return item
        }))
      }
    }
    if (jobsSelect.length === 0 && unitTypesSelect.length === 0) setVariants(variants.filter(variant => variant.isComplete === 'good'))
  }, [handleInputOnChange, rulesKeys])

  useEffect(() => {
    let newJobsSelect = jobs
    let newUnitTypesSelect = unitTypes 
    let allCombinations = {}
    const otherVariants = variants.filter(item => item.id !== variant.id)
    if(variants.length > 1) {
      otherVariants.forEach(item => {
        if(item?.job === 'TODOS') newJobsSelect = ['TODOS']
        else if(item?.job && item.job !== 'TODOS') {
          if(item?.unitType === 'TODOS') newJobsSelect = newJobsSelect.filter(job => job !== 'TODOS' && job !== item.job)
          else newJobsSelect = newJobsSelect.filter(job => job !== 'TODOS')
        }
        
        if(item?.unitType === 'TODOS') newUnitTypesSelect = ['TODOS']
        else if(item?.unitType && item.unitType !== 'TODOS') {
          if(item?.job === 'TODOS')  newUnitTypesSelect = newUnitTypesSelect.filter(type => type !== 'TODOS' && type !== item.unitType)
          else newUnitTypesSelect = newUnitTypesSelect.filter(type => type !== 'TODOS')
        }
      })
    }

    newJobsSelect.forEach(newJob => {
      newUnitTypesSelect.forEach(newType => {
        allCombinations[`${newJob} ${newType}`] = {job: newJob, unitType: newType, used: false}
      })
    })

    otherVariants.forEach(item => {
      if(item?.job && item?.unitType && allCombinations[`${item.job} ${item.unitType}`]) allCombinations[`${item.job} ${item.unitType}`] = {job: item.job, unitType: item.unitType, used: true}
      if(item?.job === 'CHOFER') {
        delete allCombinations[`CHOFER_SOLO ${item.unitType}`]
        delete allCombinations[`CHOFER_AYUDANTE ${item.unitType}`]
      } else if(item?.job?.includes('CHOFER_')) delete allCombinations[`CHOFER ${item.unitType}`]
    })

    let jobSet = new Set()
    let unitTypeSet = new Set()
    Object.keys(allCombinations).forEach(combination => {
      const combinationObj = allCombinations[combination]
      if(!combinationObj.used) {
        if(variant.unitType && variant.job) {
          if(variant.unitType === combinationObj.unitType) jobSet.add(combinationObj.job)
          if(variant.job === combinationObj.job) unitTypeSet.add(combinationObj.unitType)
        }
        if(variant.unitType && !variant.job) {
          if(variant.unitType === combinationObj.unitType) jobSet.add(combinationObj.job)
          unitTypeSet.add(combinationObj.unitType)
        } 
        if(variant.job && !variant.unitType) {
          if(variant.job === combinationObj.job) unitTypeSet.add(combinationObj.unitType)
          jobSet.add(combinationObj.job)
        }
        if(!variant.unitType && !variant.job) {
          unitTypeSet.add(combinationObj.unitType)
          jobSet.add(combinationObj.job)
        }
      }
    })

    if(variant?.job === 'CHOFER') {
      allCombinations[`CHOFER ${variant.unitType}`] = {job: 'CHOFER', unitType: variant?.unitType, used: true}
      allCombinations[`CHOFER_SOLO ${variant.unitType}`] = {job: 'CHOFER_SOLO', unitType: variant?.unitType, used: true}
      allCombinations[`CHOFER_AYUDANTE ${variant.unitType}`] = {job: 'CHOFER_AYUDANTE', unitType: variant?.unitType, used: true}
    } else if(variant.job && variant.unitType) allCombinations[`${variant.job} ${variant.unitType}`] = {job: variant?.job, unitType: variant?.unitType, used: true}

    newJobsSelect = Array.from(jobSet)
    newUnitTypesSelect = Array.from(unitTypeSet)
    setJobsSelect(newJobsSelect)
    setUnitTypesSelect(newUnitTypesSelect)
    
    if (variant.job === 'TODOS' && variant.unitType === 'TODOS' || variant.isComplete === 'bad') setNewVariants(false)
    else setNewVariants(Object.keys(allCombinations).filter(combination => !allCombinations[combination].used).length !== 0)
  }, [variants])

  useEffect(() => {
    if(periodCalc === 'SEMANAL') {
      if(prePayrollBaseCalcsFiltered.length !== prePayrollBaseCalcs2.length) setPrePayrollBaseCalcsFiltered(prePayrollBaseCalcs2)
      if(prePayrollBaseCalc === 'MENSUAL') {
        handleNewValues({
          unitType: unitType,
          job: job,
          prePayrollBaseCalc: '',
          tabulatorUse: tabulatorUse,
          homologation: homologation
        })
      }
    } else if(periodCalc === 'MENSUAL') {
      if(prePayrollBaseCalcsFiltered.length !== prePayrollBaseCalcs1.length) setPrePayrollBaseCalcsFiltered(prePayrollBaseCalcs1)
      if(prePayrollBaseCalc === 'DIARIO' || prePayrollBaseCalc === 'PROMEDIO_DIARIO_SEMANAL') {
        handleNewValues({
          unitType: unitType,
          job: job,
          prePayrollBaseCalc: '',
          tabulatorUse: tabulatorUse,
          homologation: homologation
        })
      }
    }
  }, [periodCalc])

  return (
    <>
      <FormControl fullWidth style={{ display: 'flex', gap: 10, marginTop: 20, alignItems: 'center' }}>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Tipo de puesto *</InputLabel>
          <Select
            name="job"
            value={job}
            onChange={e => handleInputOnChange(e)}
            label="Tipo de puesto *"
            disabled={deleteMode}
          > 
            { jobsSelect.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Tipo de unidad *</InputLabel>
          <Select
            name="unitType"
            value={unitType}
            onChange={e => handleInputOnChange(e)}
            label="Tipo de unidad *"
            disabled={deleteMode}
          > 
            { unitTypesSelect.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Periodo base de calculo *</InputLabel>
          <Select
            name="prePayrollBaseCalc"
            value={prePayrollBaseCalc}
            onChange={e => handleInputOnChange(e)}
            label="Periodo base de calculo *"
            disabled={deleteMode}
          > 
            { prePayrollBaseCalcsFiltered.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Uso del tabulador *</InputLabel>
          <Select
            name="tabulatorUse"
            value={tabulatorUse}
            onChange={e => handleInputOnChange(e)}
            label="Uso del tabulador *"
            disabled={deleteMode}
          > 
            { tabulatorUses.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <FormControl fullWidth variant="outlined">
          <InputLabel>Homologación *</InputLabel>
          <Select
            name="homologation"
            value={homologation}
            onChange={e => handleInputOnChange(e)}
            label="Homologación *"
            disabled={deleteMode}
          > 
            { homologations.map(item => <MenuItem key={item} value={item}>{item}</MenuItem>) }
          </Select>
        </FormControl>
        <Box style={{display: 'flex', justifyContent: 'space-between', marginTop: 30, width: '98%'}}>
          <Typography style={{ alignSelf: 'center' }}>Agregar Reglas de Variante</Typography>
          <RegularButton disabled={!newRules} round justIcon color="info" style={{ margin: 10 }} onClick={() => setRules([...rules, {itemId: generateRandomID(32), name: "Nueva Regla", isComplete: 'bad'}])}>
            <AddIcon style={{ margin: 0 }}/>
          </RegularButton>
        </Box>
          { 
          rules.map(rule => (
            <Box style={{marginTop: 10, width: '100%'}}>
              <ContractRuleAccordion 
                key={rule.itemId} 
                setNewRules={setNewRules} 
                setRulesKeys={setRulesKeys} 
                rulesKeys={rulesKeys} 
                setRules={setRules} 
                rule={rule} 
                rules={rules}
                idStation={idStation}
              />
            </Box>
          )) 
          }
      </FormControl>
    </>
  )
})
